
import "./Resume.css";
import config from "../Config/Config.json";

function Resume() {


    // const mResumeData = [
    //     {
    //         title: "Work Experience",
    //         isPointer: false,
    //         data : [
    //             {
    //                 date: "2025 - Present",
    //                 position: "UI/UX Designer",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font."
    //             },
    //             {
    //                 date: "2025 - Present",
    //                 position: "UI/UX Designer",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font."
    //             },
    //             {
    //                 date: "2025 - Present",
    //                 position: "UI/UX Designer",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font."
    //             },
    //         ],
    //     },
    //     {
    //         title: "Education",
    //         isPointer: false,
    //         data : [
    //             {
    //                 date: "2025 - Present",
    //                 position: "Establishment name| Degree",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy."
    //             },
    //             {
    //                 date: "2025 - Present",
    //                 position: "UI/UX Designer",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy."
    //             },
    //             {
    //                 date: "2025 - Present",
    //                 position: "UI/UX Designer",
    //                 desc: "I'm a paragraph. Click here to add your own text and edit me. It’s easy."
    //             },
    //         ],
    //     },
    //     {
    //         title: "Skills & Experties",
    //         isPointer: true,
    //         data : [
    //             "I'm a paragraph. Click here to add your own text and edit me.",
    //             "I'm a paragraph. Click here to add your own text and edit me.",
    //             "I'm a paragraph. Click here to add your own text and edit me.",
    //             "I'm a paragraph. Click here to add your own text and edit me."
    //         ],
    //     },
    // ];
    
  return (
  <div className="resume-div">
    <hr className="divider"/>
    <h1>Resume</h1>
    <br/>
    {config.resume_section.map((item, index) => (
      <div key={index} className="with-divider">
        <br/>
        <div className="resume-section">
          <div className="resume-heading">
            <span>{item.title}</span>
            <hr className="divider" style={{ width: "250px" }}/>
          </div>
          <div className="resume-details">
            {item.isPointer ? (
              <ul>
                {item.data.map((dataItem, i) => (
                  <li key={i}>{dataItem}</li>
                ))}
              </ul>
            ) : (
              <div>
                {item.data.map((dataItem, j) =>
                  <ResumeData
                    key={j}
                    dateDuration={dataItem.date}
                    positionTitle={dataItem.position}
                    descValue={dataItem.desc}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>
);

}

function ResumeData({ dateDuration, positionTitle, descValue }) {
  return (
    <div className="resume-data-section">
      <span className="resume-title">{dateDuration}</span>
      <div className="resume-info">
        <div className="resume-role">{positionTitle}</div>
        <div className="resume-role-desc">{descValue}</div>
      </div>
    </div>
  );
}
export default Resume;